module.exports = __webpack_public_path__ + "img/book-white.ab4ed89.svg";